// Подсказка о состоянии экрана (components/Callout/README.md): иконка и одна-две строки.
// Ошибка формы — с кодом; с номером операции — строкой ниже «Код … · операция …» и
// «Скопировать номер» (FR-028; 002, contracts/ui.md).
import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from '../lib/cx.ts';
import { Icon } from '../lib/icon.tsx';
import type { LucideIcon } from '../lib/icon.tsx';
import { OperationCode } from './OperationCode.tsx';

export type CalloutTone = 'info' | 'ok' | 'warn' | 'bad';

const toneIcon: Record<CalloutTone, LucideIcon> = {
  info: Info,
  ok: CircleCheck,
  warn: TriangleAlert,
  bad: CircleAlert,
};

export interface CalloutProps {
  tone?: CalloutTone;
  /** Начало жирным: «Подсказка.». */
  lead?: ReactNode;
  children: ReactNode;
  /** Действие ссылкой в конце: «Повторить». */
  action?: ReactNode;
  /** Код ошибки после текста: «. Код ошибки NET-001». */
  code?: string;
  /** Номер операции из ответа сервера: строкой ниже «Код SYS-001 · операция 7F3K-92QD-1A2B». */
  operation?: string;
  icon?: LucideIcon;
  /** role="status" или role="alert" для полосы, которая появляется на ходу. */
  role?: 'status' | 'alert';
  className?: string;
}

export function Callout({
  tone = 'info',
  lead,
  children,
  action,
  code,
  operation,
  icon,
  role,
  className,
}: CalloutProps) {
  return (
    <div className={cx('t-callout', tone, className)} role={role}>
      <Icon icon={icon ?? toneIcon[tone]} className="t-ico" />
      <div>
        {lead != null ? <b>{lead} </b> : null}
        {children}
        {code != null && !operation ? (
          <>
            . Код ошибки <span className="kp-code">{code}</span>
          </>
        ) : null}
        {action != null ? <> {action}</> : null}
        {code != null && operation ? (
          <OperationCode code={code} operation={operation} className="kp-opline" />
        ) : null}
      </div>
    </div>
  );
}
